import React, { useEffect, useLayoutEffect, useState } from "react";

import { StepContainer, NavigationButtons, InfoBox } from "../index";

import { useWizard } from "../../wizard";

import { contentApi } from "../../services/contentApi";

import { contentKeys } from "../../constants/contentKeys";

const FALLBACK_CONTENT = [
  "Samtykkeerklæringen er nu registreret i demonstrationen. Begge forældre har underskrevet med den simulerede MitID-løsning.",

  "På den rigtige løsning sendes kvittering til hver forælder og til kommunen via de gældende kanaler.",
];

const DriverConsentConfirmationStep: React.FC = () => {
  const { updateSelfServiceData } = useWizard();

  const [body, setBody] = useState<string[] | null>(null);

  useEffect(() => {
    contentApi
      .getByKey(contentKeys.koerekort_samtykke.dlc_confirmation)
      .then((content) => {
        if (content?.body && content.body.length > 0) {
          setBody(content.body);
        } else {
          setBody(FALLBACK_CONTENT);
        }
      });
  }, []);

  useLayoutEffect(() => {
    updateSelfServiceData("isCompleted", true);
  }, [updateSelfServiceData]);

  return (
    <StepContainer title="Samtykke registreret">
      <InfoBox type="success">
        {(body ?? FALLBACK_CONTENT).map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </InfoBox>

      <NavigationButtons showBack={false} showNext={false} />
    </StepContainer>
  );
};

export default DriverConsentConfirmationStep;
